'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import type { ComponentProps } from 'react';
import { useState } from 'react';
import { PhotoReviewSwiper } from '@/app/donation/_components/PhotoReviewSwiper';
import { GIFT_REVIEW_SORT_TYPE } from '@/app/donation/constants';
import type { GiftReviewSortType } from '@/app/donation/types';
import { TABS } from '../../../../constants';
import type { GiftDetailPageProps } from '../../../../page';
import { ResponsiveDivider } from '../../../GiftDetailTemplate/ResponsiveDivider';
import { ReviewSummary } from '../../../ReviewSummary';
import { ReviewList } from './_components/ReviewList';
interface GiftTabContentReviewProps {
  reviewRating?: number;
  reviewCount: number;
  reviewList: ComponentProps<typeof ReviewList>['initialList'];
  reviewTotalCount: number;
  photoReviewList: ComponentProps<typeof PhotoReviewSwiper>['photoReviewList'];
  photoReviewCount: number;
  productNumber: string;
  searchParams?: GiftDetailPageProps['searchParams'];
}
export const GiftTabContentReview = t0 => {
  const $ = _c(35);
  const {
    reviewRating,
    reviewCount,
    reviewList,
    reviewTotalCount,
    photoReviewList,
    photoReviewCount,
    productNumber
  } = t0;
  const [reviewSort, setReviewSort] = useState(GIFT_REVIEW_SORT_TYPE.LATEST);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("flex flex-col pt-16", "mobile-tablet:pt-32");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== reviewCount || $[2] !== reviewRating) {
    t2 = <ReviewSummary reviewRating={reviewRating} reviewCount={reviewCount} className="mobile-tablet:mx-20" />;
    $[1] = reviewCount;
    $[2] = reviewRating;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== photoReviewCount || $[5] !== photoReviewList || $[6] !== productNumber) {
    t3 = <PhotoReviewSwiper photoReviewList={photoReviewList} photoReviewCount={photoReviewCount} productNumber={productNumber} className="mobile-tablet:px-20" />;
    $[4] = photoReviewCount;
    $[5] = photoReviewList;
    $[6] = productNumber;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ResponsiveDivider className="h-0" />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setReviewSort(GIFT_REVIEW_SORT_TYPE.LATEST);
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = reviewSort !== GIFT_REVIEW_SORT_TYPE.RATING_DESC;
  let t7;
  if ($[10] !== t6) {
    t7 = cn("font-700 text-Gray-500 typo-body4", {
      "text-Gray-600": t6
    });
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = <button type="button" onClick={t5} className={t7}>최신순</button>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="h-16 w-1 bg-Gray-300" />;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setReviewSort(GIFT_REVIEW_SORT_TYPE.RATING_DESC);
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = reviewSort === GIFT_REVIEW_SORT_TYPE.RATING_DESC;
  let t12;
  if ($[16] !== t11) {
    t12 = cn("font-700 text-Gray-500 typo-body4", {
      "text-Gray-600": t11
    });
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t12) {
    t13 = <button type="button" onClick={t10} className={t12}>평점 높은순</button>;
    $[18] = t12;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t13 || $[21] !== t8) {
    t14 = <div className="flex items-center justify-end gap-8 border-b border-Gray-200 px-12 py-16">{t8}{t9}{t13}</div>;
    $[20] = t13;
    $[21] = t8;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== productNumber || $[24] !== reviewList || $[25] !== reviewSort || $[26] !== reviewTotalCount) {
    t15 = <ReviewList initialList={reviewList} totalCount={reviewTotalCount} sortType={reviewSort} productNumber={productNumber} />;
    $[23] = productNumber;
    $[24] = reviewList;
    $[25] = reviewSort;
    $[26] = reviewTotalCount;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t14 || $[29] !== t15) {
    t16 = <div className="flex flex-col">{t14}{t15}</div>;
    $[28] = t14;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t16 || $[32] !== t2 || $[33] !== t3) {
    t17 = <section className={t1} id={TABS.REVIEW}>{t2}{t3}{t4}{t16}</section>;
    $[31] = t16;
    $[32] = t2;
    $[33] = t3;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  return t17;
};